import React from "react";
import { _get } from "../../Api";
import { getArticles } from "../../store/articles/ArticlesApi";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { IconButton, ListItemIcon } from "@material-ui/core";
import { Done, ErrorOutline, Sync } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import cloudStore from "../../store/CloudStore";

function SyncButton() {
  const [refreshing, setRefreshing] = React.useState("NONE");

  const handleRefresh = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setRefreshing("REFRESHING");
    _get("/nova/merchant/" + cloudStore.merchant.id + "/syncmenu")
      .then(() => {
        getArticles(cloudStore.merchant.id);
        setRefreshing("DONE");
      })
      .catch((e) => {
        console.log(e);
        setRefreshing("ERROR");
      });
  };

  return (
    <AuthorizationWrapper
      permission={"sync.articles"}
      child={
        <ListItemIcon>
          <IconButton title={"Synchroniseren"} onClick={handleRefresh}>
            {refreshing === "NONE" ? (
              <Sync />
            ) : refreshing === "REFRESHING" ? (
              <CircularProgress size={20} color="primary" />
            ) : refreshing === "ERROR" ? (
              <ErrorOutline />
            ) : refreshing === "DONE" ? (
              <Done />
            ) : (
              <Sync />
            )}
          </IconButton>
        </ListItemIcon>
      }
    />
  );
}

export default SyncButton;
